import { render, staticRenderFns } from "./PicklItem.vue?vue&type=template&id=8a1dfc2c&scoped=true&"
import script from "./PicklItem.vue?vue&type=script&lang=ts&"
export * from "./PicklItem.vue?vue&type=script&lang=ts&"
import style0 from "./PicklItem.vue?vue&type=style&index=0&id=8a1dfc2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1dfc2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a1dfc2c')) {
      api.createRecord('8a1dfc2c', component.options)
    } else {
      api.reload('8a1dfc2c', component.options)
    }
    module.hot.accept("./PicklItem.vue?vue&type=template&id=8a1dfc2c&scoped=true&", function () {
      api.rerender('8a1dfc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PicklItem.vue"
export default component.exports